<template>
  <button v-bind="$attrs" @click="handleClick" type="button" class="change-btn">
    <slot></slot>
    <icon-base viewBox="0 0 18 18" class="change-btn__icon">
      <icon-edit/>
    </icon-base>
  </button>
</template>

<script>
export default {
  name: "EditBtn",
  methods: {
    // Просто дефолтное поведение, чтоб @click работал на компоненте
    handleClick(evt) {
      this.$emit('click', evt);
    }
  },
}
</script>